import React, { Suspense } from 'react';
import { Route, Redirect } from 'react-router-dom';
import useAccessPolicy from '../../hooks/useAccessPolicy';
import Routes from '../../enums/route';
import Loading from './Loading';
const ProtectedRoute = ({ component: Component, policy, ...rest }) => {
    const hasAccess = useAccessPolicy(policy);
    return (<Route {...rest} render={(routeProps) => {
            if (hasAccess === undefined)
                return <Loading />;
            if (hasAccess === false)
                return <Redirect to={Routes.Home}/>;
            return (<Suspense fallback={<Loading />}>
            <Component {...routeProps}/>
          </Suspense>);
        }}/>);
};
export default ProtectedRoute;
